import React, { useState, useEffect, useRef } from 'react';
// import style from './style.module.css';
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import wave2 from '../../assets/WhatWeDo/wave2.png'
import WeD2 from '../../assets/WhatWeDo/WeD2.png'
import WeD3 from '../../assets/WhatWeDo/WeD3.png'
import Thick from '../../assets/WhatWeDo/thick.svg'
import Thick1 from '../../assets/WhatWeDo/thick1.svg'

import thickpng from '../../assets/WhatWeDo/thick.png'

import left1 from '../../assets/join/left1.png';
import left2 from '../../assets/join/left2.png';
import left3 from '../../assets/join/left3.png';
import left4 from '../../assets/join/left4.png';
import left5 from '../../assets/join/left5.png';
import right1 from '../../assets/join/right1.png';
import right2 from '../../assets/join/right2.png';
import right3 from '../../assets/join/right3.png';
import right4 from '../../assets/join/right4.png';
import right5 from '../../assets/join/right5.png';
import right6 from '../../assets/join/right6.png';
import right7 from '../../assets/join/right7.png';
import right8 from '../../assets/join/right8.png';
import right9 from '../../assets/join/right9.png';
import wave3 from '../../assets/WhatWeDo/wave3.png'
import frame from '../../assets/WhatWeDo/frame.png'
import frame2 from '../../assets/WhatWeDo/frame2.png'
import frame7 from '../../assets/WhatWeDo/frame7.png'
import wave1 from '../../assets/WhatWeDo/wave1.png'
import left6 from '../../assets/join/left6.png'
import left7 from '../../assets/join/left7.png'
import left8 from '../../assets/join/left8.png'


import InfoCard from "../../screens/InfoCard/InfoCard";
import { courseInfoCardData, infoCardData } from "../../constant";

import wave from '../../assets/WhatWeDo/wave.png'
import WeD1 from '../../assets/WhatWeDo/WeD1.png'
import WeD9 from '../../assets/WhatWeDo/WeD9.png'

import bell from '../../assets/WhatWeDo/bell.svg'
import style from './style.module.css'
import { FamilyRestroom } from '@mui/icons-material';

export default function OurTrainer() {
  const navigate = useNavigate();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { TrainerContainer, fontpaddingleft, custom_frame2, row_left, row_right, title, title2, wed9x, block_height3, btn_alignment2, list, svg_icon, block_height, block_height1, custom_row, custom_row2, svg_icon1, block_height2, wed2, btn_alignment, list2, Join_Best, Join_descrip, col_middle, col_left, col_right, leftimg1, leftimg2, leftimg3, leftimg4, leftimg5, rightimg1, rightimg2, rightimg3, rightimg4, rightimg5 } = style;
  const [animate, setAnimate] = useState(false);
  const sectionRef = useRef(null); // Ref for the section to observe
  const [activeSection, setActiveSection] = useState(1);


  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         setAnimate(true); // Trigger animation when section is visible
  //       } else {
  //         setAnimate(false); // Reset animation when section is out of view
  //       }
  //     },
  //     {
  //       threshold: 0.5, // Trigger when 50% of the section is visible
  //     }
  //   );

  //   if (sectionRef.current) {
  //     observer.observe(sectionRef.current);
  //   }

  //   return () => {
  //     if (sectionRef.current) {
  //       observer.disconnect();
  //     }
  //   };
  // }, []);
  useEffect(() => {
    let interval; 

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true); 

          
          interval = setInterval(() => {
            setActiveSection((prev) => (prev === 1 ? 2 : 1));
          }, 3000); 
        } else {
          setAnimate(false); 

          
          clearInterval(interval);
          setActiveSection(1);
        }
      },
      {
        threshold: 0.5, 
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
      clearInterval(interval); 
    };
  }, []);


  return (
    <div
      className="container-sm-fluid  pb-4  m-sm-0 bg-sm-none "
    >
      <div className={`container-sm-fluid ${custom_frame2} `}
        style={{
          // backgroundColor: '#5A8C75',
          backgroundImage: `url(${frame2})`,
          // backgroundSize: 'cover',
          // backgroundPosition: "top center",
          backgroundSize: 'cover',
          backgroundPosition: "bottom",
          backgroundRepeat: 'no-repeat',

        }}>
        <InfoCard data={infoCardData} count={true} gradient={false} />

      </div>


      {/* First Row */}
      <div className="container-fluid mt-sm-5 mt-lg-0 pl-4  p-sm-0  "
        style={{
          // backgroundColor: '#5A8C75',
          backgroundImage: `url(${frame7})`,
          backgroundSize: 'contain',
          backgroundPosition: "center top",
          // backgroundSize: 'cover',
          // backgroundPosition: "top right",
          backgroundRepeat: 'no-repeat',
          padding: 0,
        }}
      >
        <div className="row align-items-center pb-sm-5 pr-sm-5 ">
          <div className="col-lg-6 p-0 pl-sm-4 col-md-6 col-sm-12 pr-4">
            <img src={WeD9} alt="Wed9" className={`img-container w-100 pr-sm-3 pr-lg-5 pl-lg-1 ${wed9x}`} />
          </div>
          {/* <div className="col-1"></div> */}
          <div className="pl-sm-5 col-lg-6 col-md-6 col-sm-12 pb-4 pb-lg-0 text-sm-center text-lg-left  ">
            <h1 className={`pl-sm-2 mt-2 ${title}`}>
              <span style={{ color: '#160A54', fontFamily: "Barlow,sans-serif" }}>Find your   </span>
              <span style={{ color: '#04642D', fontFamily: "Barlow,sans-serif" }}> Next Impact-Driven Talent Force </span>
            </h1>
            <div className={`d-sm-block d-none ${block_height}`}></div>

            <div className="row mt-3 font21 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0">
              <div className={`col-1 p-lg-0 ${custom_row}`}>
                <img src={Thick} alt={Thick} className={`${svg_icon} `} />
              </div>
              <div className="col-11"><p className={`font19x pl-4 fontpaddingleft ${list}`}> Get access to pre-vetted candidates who match your business's specific needs.</p></div>
            </div>
            <div className="row mt-3 font20 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0">
              <div className={`col-1 p-lg-0 ${custom_row}`}>
                <img src={Thick} alt={Thick} className={`${svg_icon} `} />
              </div>
              <div className="col-11">
                <p className={`font19x pl-4 fontpaddingleft ${list}`}> From sourcing to shortlisting, we handle every step so you can focus on growth.</p></div>
            </div>
            <div className="row mt-3 font20 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0">
              <div className={`col-1 p-lg-0 ${custom_row}`}>
                <img src={Thick} alt="Thick Icon" className={`${svg_icon}`} />
              </div>
              <div className="col-11">
                <p className={`font19x pl-4 fontpaddingleft ${list}`}>
                  Our timely services and ethical recruitment ensures the right fit for both your company and the candidate.
                </p>
              </div>
            </div>

            <div className={`d-sm-block d-none ${block_height1}`}></div>
            <div className={`row pb-sm-5 pl-3 mt-3 ml-sm-2 mt-sm-2 pt-sm-5 align-items-center mt-lg-0 ${btn_alignment2}`}>
              <button className="Preview_candidates_btn  mr-4 mt-sm-1 " onClick={() => navigate('/#coursesWeOffer')} >Preview candidates</button>
              <button className="hire_now_btn  mt-sm-1   " onClick={() => navigate('/#coursesWeOffer')} >Hire now</button>
            </div>
          </div>
        </div>
      </div>


      {/* Second Row */}
      <div className="container-fluid mt-sm-5 pl-4  p-sm-0 mb-lg-5"
        style={{
          // backgroundColor: '#5A8C75',
          backgroundImage: `url(${wave2})`,
          backgroundSize: 'contain',
          backgroundPosition: "center top",
          // backgroundSize: 'cover',
          // backgroundPosition: "center",
          backgroundRepeat: 'no-repeat',
          padding: 0,
        }}>
        <div className="row align-items-center pb-5">
          <div className="col-lg-6  p-0 pl-sm-4  col-md-6 col-sm-12 pr-4">
            <img src={WeD2} alt="Wed2" className={`img-container w-100 pr-sm-3 ${wed2} pl-lg-1`} />
          </div>
          <div className="pl-sm-4 col-lg-6 col-md-6 col-sm-12 pb-4 pb-lg-0 text-sm-center text-lg-left  ">

            <div className={`d-sm-block d-none ${block_height3}`}></div>


            {/* <h1 className={`pl-sm-2 mt-2 ${title}`}>
              <span style={{ color: '#160A54', fontFamily: "Barlow,sans-serif" }}>Find your   </span>
              <span style={{ color: '#04642D', fontFamily: "Barlow,sans-serif" }}> Next Impact-Driven Talent Force </span>
            </h1> */}
            <h1 className={`pl-sm-2  pb-sm-5 mt-5 pb-lg-0 pr-lg-5 mr-lg-5 ${title2}`}>
              <span style={{ color: '#160A54', fontFamily: "Barlow,sans-serif" }}> We help you to match  </span>
              <span style={{ color: '#04642D', fontFamily: "Barlow,sans-serif" }}> Smart job matches tailored to your
                expertise and goals</span>
            </h1>
            <div className={`d-sm-block d-none ${block_height2}`}></div>

            <div className="row mt-3 font20 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0 pr-lg-5  pb-lg-2">
              <div className={`col-1 p-lg-0 ${custom_row2}`}>
                <img src={Thick1} alt={Thick} className={`${svg_icon1} `} />
              </div>
              <div className="col-11">
                <p className={`font19x pl-4 fontpaddingleft ${list2} mr-lg-5 pr-lg-5`}>We offer support in building a career path that matches your goals.</p></div>
            </div>

            <div className="row mt-3 font20 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0 pr-lg-5 pb-lg-2">
              <div className={`col-1 p-lg-0 ${custom_row2}`}>
                <img src={Thick1} alt={Thick} className={`${svg_icon1} `} />
              </div>
              <div className="col-11">
                <p className={`font19x pl-4 fontpaddingleft ${list2}  mr-lg-5 pr-lg-5`}>We connect you with roles that align with your qualifications and interests.</p></div>
            </div>

            <div className="row mt-3 font20 align-items-center justify-content-start pl-sm-2 pl-lg-0 m-lg-0 pr-lg-5">
              <div className={`col-1 p-lg-0 ${custom_row2}`}>
                <img src={Thick1} alt={Thick} className={`${svg_icon1} `} />
              </div>
              <div className="col-11">
                <p className={`font19x pl-4 fontpaddingleft ${list2}  mr-lg-5 pr-lg-4`}>Receive personalized tips and support to help you stand out and land the job</p>
              </div>
            </div>

            <div className={`row pb-sm-5 pl-3 mt-3 ml-sm-2 mt-sm-2 pt-sm-5 align-items-center ${btn_alignment}`}>
              <button className="get_job_btn  mr-4 mt-sm-1" style={{ fontFamily: "Inter,serif " }} onClick={() => navigate('/#coursesWeOffer')} >Get job matches</button>
              <button className="learn_more_btn   mt-sm-1   " style={{ fontFamily: "Inter,serif " }} onClick={() => navigate('/#coursesWeOffer')} >Learn more</button>
            </div>
          </div>
        </div>
      </div>


      {/* Third Row */}
      <div className='container-fluid d-md-block d-none p-0 m-0 mb-5 mt-5' ref={sectionRef}>
        <div className="row align-items-center p-sm-4 pr-0 p-lg-0 pb-5">

          <div className={`${col_left}`} >
            {activeSection === 1 && 
            <div className={`d-flex flex-column align-items-end pr-2 p-lg-0 ${row_left} ${row_left}`}>
              <div className={`col-12 text-right pl-0  ${animate ? 'animated-left' : ''}`} style={{ paddingRight: "2.9rem " }}>
                <img src={left1} alt="Left 1" className={`${leftimg1}`} />
              </div>
              <div className={`col-12 text-left ${animate ? 'animated-right' : ''}`} style={{ paddingLeft: "1.5rem " }}>
                <img src={left2} alt="Left 2" className={`${leftimg2}`} />
              </div>
              <div className={`col-12 text-right pl-0  ${animate ? 'animated-left' : ''}`} style={{ paddingRight: "6px", marginBottom: "75px " }}>
                <img src={left3} alt="Left 3" className={`${leftimg3}`} />
              </div>
              <div className={`col-12 text-left p-0 ${animate ? 'animated-right' : ''}`}>
                <img src={left4} alt="Left 4" className={`${leftimg4}`} />
              </div>
              <div className={`col-12 text-right  pl-0 ${animate ? 'animated-left' : ''}`} style={{ paddingRight: "2.5rem " }}>
                <img src={left5} alt="Left 5" className={`${leftimg5}`} />
              </div>
            </div> }
            {activeSection === 2 && 
            <div className={`d-flex flex-column align-items-end pr-2 p-lg-0 ${row_left} `}>
              <div className={`col-12 text-right pl-0  ${animate ? 'animated-left' : ''}`} style={{ paddingRight: "2.9rem " }}>
                <img src={left6} alt="Left 1" className={`${leftimg1}`} style={{ width: "100px", height: "auto" }}/>
              </div>
              <div className={`col-12 text-left ${animate ? 'animated-right' : ''}`} style={{ paddingLeft: "1.5rem " }}>
                <img src={left7} alt="Left 2" className={`${leftimg2}`} style={{ width: "100px", height: "auto" }}/>
              </div>
              <div className={`col-12 text-right pl-0  ${animate ? 'animated-left' : ''}`} style={{ paddingRight: "2.9rem " }}>
                <img src={left8} alt="Left 1" className={`${leftimg1}`} style={{ width: "100px", height: "auto" }}/>
              </div>
            </div>}
          </div>


          <div className={`text-center p-0 m-0 ${col_middle}`} >
            <h1 className={`mb-1 text-center ${Join_Best}`}>
              <span style={{ color: '#160A54' }}>JOIN THE BEST</span>
            </h1>

            <div className="mx-auto d-flex align-items-center justify-content-center">
              <span className={`mb-5 text-center ${Join_descrip}`}>
                Powering 5,000+ of the best customer experiences
              </span>
            </div>
            <div className="text-center">
              <button
                className="free_trail_btn mr-5"
                style={{
                  backgroundColor: "#04642D",
                  padding: '17px 32px',
                  fontSize: '1.1rem',
                  fontFamily: "Inter, serif",
                }}
                onClick={() => window.open('https://calendly.com/talentexpertz-hrsp/30min?month=2025-03', '_blank')}
              >

                Free Trial
              </button>
              <button
                className="get_free_demo"
                style={{ fontFamily: "Inter, serif" }}
                onClick={() => window.open('https://calendly.com/talentexpertz-hrsp/30min?month=2025-03', '_blank')}
              >
                Get Free Demo
              </button>
            </div>
          </div>

          <div className={`${col_right}`}>
  
  {activeSection === 1 && 
  <div className={`d-flex flex-column align-items-start pl-4 p-lg-0 ${row_right} ${animate && activeSection === 1 ? 'show-section' : 'hide-section'}`}>
    <div className={`col-12 text-left mb-4 ${animate ? 'animated-right' : ''}`}>
      <img src={right1} alt="Right 1" className={`${rightimg1}`} />
    </div>
    <div className={`col-12 text-right pr-5 mb-4 ${animate ? 'animated-left' : ''}`}>
      <img src={right2} alt="Right 2" className={`${rightimg2}`} />
    </div>
    <div className={`col-12 text-left mb-5 ${animate ? 'animated-right' : ''}`}>
      <img src={right3} alt="Right 3" className={`${rightimg3}`} />
    </div>
    <div className={`col-12 text-right p-0 mb-5 ${animate ? 'animated-left' : ''}`}>
      <img src={right4} alt="Right 4" className={`${rightimg4}`} />
    </div>
    <div className={`col-12 text-left ${animate ? 'animated-right' : ''}`}>
      <img src={right5} alt="Right 5" className={`${rightimg5}`} />
    </div>
  </div>}

  {activeSection === 2 && 
  <div className={`d-flex flex-column align-items-start pl-4 p-lg-0 ${row_right} ${animate && activeSection === 2 ? 'show-section' : 'hide-section'}`}>
    <div className={`col-12 text-left mb-4 ${animate ? 'animated-right' : ''}`}>
      <img src={right6} alt="Right 1" className={`${rightimg1}`} style={{ width: "100px", height: "auto" }} />
    </div>
    <div className={`col-12 text-right pr-5 mb-4 ${animate ? 'animated-left' : ''}`}>
      <img src={right7} alt="Right 2" className={`${rightimg2}`}  style={{ width: "100px", height: "auto" }}/>
    </div>
    <div className={`col-12 text-right p-0 mb-5 ${animate ? 'animated-left' : ''}`}>
      <img src={right8} alt="Right 4" className={`${rightimg4}`}  style={{ width: "100px", height: "auto" }}/>
    </div>
    <div className={`col-12 text-left ${animate ? 'animated-right' : ''}`}>
      <img src={right9} alt="Right 5" className={`${rightimg5}`}  style={{ width: "100px", height: "auto" }}/>
    </div>
  </div>}

</div>

        </div>
      </div>



      {/* <div className='container-fluid d-md-block d-none p-0 m-0'>
        <div className="row align-items-center p-sm-4  pr-0  ">
          <div className="col-lg-4 col-md-4 col-sm-12  pr-sm-5 pl-sm-5 ">
            <div className="d-flex flex-column align-items-end pr-2">
              <div className={`col-12 text-right pl-0    pr-4 ${animate ? 'animated-left' : ''}`}>
                <img src={left1} alt="Left 1" style={{ width: "43%" }} />
              </div>
              <div className={`col-12 text-left pl-sm-2 p-0 ${animate ? 'animated-right' : ''}`}>
                <img src={left2} alt="Left 2" style={{ width: "35%", }} />
              </div>
              <div className={`col-12 text-right pr-0 pl-0 mb-5 ${animate ? 'animated-left' : ''}`}>
                <img src={left3} alt="Left 3" style={{ width: "58%" }} />
              </div>

              <div className={`col-12 text-left p-0 ${animate ? 'animated-right' : ''}`}>
                <img src={left4} alt="Left 4" style={{ width: "45%" }} />
              </div>
              <div className={`col-12 text-right  pr-sm-3 pl-0 ${animate ? 'animated-left' : ''}`}>
                <img src={left5} alt="Left 5" style={{ width: "38%" }} />
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-12 text-center p-0 m-0">
            <h1 className={`mb-1 text-center ${Join_Best}`}>
              <span style={{ color: '#160A54' }}>JOIN THE BEST</span>
            </h1>

            <div className="mx-auto d-flex align-items-center justify-content-center" style={{

            }} >
              <span className={`mb-5 text-center ${Join_descrip}`} >

                Powering 100,000+ of the best customer experiences

              </span>
            </div>
            <div className="text-center ">
              <button
                className="free_trail_btn mr-4"
                style={{ backgroundColor: "#04642D", padding: '17px 32px', fontSize: '1.1rem', fontFamily: "Barlow, sans-serif" }}
                onClick={() => navigate('/#coursesWeOffer')}
              >
                Free Trial
              </button>
              <button
                className="get_free_demo"
                onClick={() => navigate('/#coursesWeOffer')}
              >
                Get Free Demo
              </button>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-12  pr-sm-4 pl-sm-5">
            <div className="d-flex flex-column align-items-start pl-4 ">
              <div className={`col-12 text-left mb-4 ${animate ? 'animated-right' : ''}`}>
                <img src={right1} alt="Right 1" style={{ width: "42%", }} />
              </div>
              <div className={`col-12 text-right pr-5 mb-4   ${animate ? 'animated-left' : ''}`}>
                <img src={right2} alt="Right 2" style={{ width: "22%" }} />
              </div>
              <div className={`col-12 text-left mb-5   ${animate ? 'animated-right' : ''}`}>
                <img src={right3} alt="Right 3" style={{ width: "38%" }} />
              </div>
              <div className={`col-12 text-right p-0 mb-5 ${animate ? 'animated-left' : ''}`}>
                <img src={right4} alt="Right 4" style={{ width: "50%", }} />
              </div>
              <div className={`col-12 text-left ${animate ? 'animated-right' : ''}`}>
                <img src={right5} alt="Right 5" style={{ width: "42%", }} />
              </div>
            </div>
          </div>
        </div>
      </div> */}


    </div>
  );
}

const SliderWrapper = styled.div`
  .slick-slide {
    padding: 0 10px; /* Space between slides */
    background-color: transparent;
    
  }
  .card-style1 {
    height:400px;
    width: 18rem;
    border-radius: 16px;
    border: 1px solid #FDD8A3;
    background-color: white;
  }
  .card-style2 {
    width: 18rem;
    height:400px;
    border-radius: 16px;
    border: 1px solid #8FCEC1;
    background-color: white;
  }
  .card-style3 {
    width: 18rem;
    height:400px;
    border-radius: 16px;
    border: 1px solid #c3b25a;
    background-color: white;
  }
  .card-style4 {
    width: 18rem;
    height:400px;
    border-radius: 16px;
    border: 1px solid #60bd92;
    background-color: white;
  }
  .card-style5 {
    width: 18rem;
    height:400px;
    border-radius: 16px;
    border: 1px solid #ac6558;
    background-color: white;
  }
  .card-style6 {
    width: 18rem;
    height:400px;
    border-radius: 16px;
    border: 1px solid #81b5ad;
    background-color: white;
  }
  .slick-prev, .slick-next {
    /* background-color: white; */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slick-prev:before, .slick-next:before {
    font-size: 20px;
    color: rgb(90, 140, 117);
  }
`;
